import { h } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/classnames-utils';
import SkeletonBlock from '../../2-atoms/skeleton-block/skeleton-block';
import LabelSkeleton from '../../2-atoms/label/label-skeleton';

import { modifierList } from './props-list';

const DEFAULT_CARD_MODIFIERS = [];

const renderTextBlock = (skeletonColor) => (
  <div className="c-skeleton-block__text-wrapper">
    <SkeletonBlock modifiers={['text']} skeletonColor={skeletonColor} />
    <SkeletonBlock modifiers={['text']} skeletonColor={skeletonColor} />
    <SkeletonBlock modifiers={['text']} skeletonColor={skeletonColor} />
    <SkeletonBlock modifiers={['text']} skeletonColor={skeletonColor} />
  </div>
);

const renderTitle = (skeletonColor) => <SkeletonBlock modifiers={['title-full']} skeletonColor={skeletonColor} />;

const CardSkeleton = ({
  skeletonColor,
  modifiers = DEFAULT_CARD_MODIFIERS,
  hasTime,
  hasTextBlock,
  hasTitle,
  hasImage,
  labelModifiers,
  labelTag,
}) => {
  const classNames = getClassNames('c-card', modifiers);

  return (
    <a className={classNames}>
      <article className="c-card__wrapper">
        {hasTime && (
          <time className="c-card__date c-skeleton-block c-skeleton-block--light c-skeleton-block--label-date" />
        )}
        <div className="c-card__content">
          <LabelSkeleton skeletonColor={skeletonColor} modifiers={labelModifiers} tag={labelTag} />
          {hasTitle && renderTitle(skeletonColor)}
          {hasTextBlock && renderTextBlock(skeletonColor)}
        </div>
        {hasImage && (
          <div className="c-card__img-wrapper">
            <figure className="o-aspect-ratio o-aspect-ratio--16-10">
              <SkeletonBlock modifiers={['full']} skeletonColor={skeletonColor} />
            </figure>
          </div>
        )}
      </article>
    </a>
  );
};

CardSkeleton.propTypes = {
  skeletonColor: PropTypes.string.isRequired,
  labelModifiers: PropTypes.array,
  labelTag: PropTypes.string,
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(modifierList)),
  hasTime: PropTypes.bool,
  hasTextBlock: PropTypes.bool,
  hasTitle: PropTypes.bool,
  hasImage: PropTypes.bool,
};

export default CardSkeleton;
